export default __webpack_public_path__ + "static/media/confesiones-icon.22ba25bf.png";